export default "__VITE_ASSET__GamOgwCC__";